import {
  VENDOR_BOOKING_UPDATE,
  VENDOR_BOOKING_UPDATE_SUCCESS,
  VENDOR_BOOKING_UPDATE_ERROR,
  VENDOR_BOOKING_UPDATE_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorBookingUpdate = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_BOOKING_UPDATE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_BOOKING_UPDATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case VENDOR_BOOKING_UPDATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_BOOKING_UPDATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorBookingUpdate;
